import React from 'react';
import { motion } from 'framer-motion';
export function ContactCTA() {
  return <section id="contact" className="relative py-32 md:py-48 flex items-center justify-center overflow-hidden" data-id="element-17">
      {/* Background */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1920&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed'
    }} data-id="element-18" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 z-10 bg-black/60" data-id="element-19" />

      {/* Content */}
      <div className="relative z-20 max-w-3xl mx-auto px-6 text-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-21">
          <div className="w-12 h-[1px] bg-copper mx-auto mb-8" data-id="element-22" />

          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-6" data-id="element-23">
            Begin Your Story at Copper Crest
          </h2>

          <p className="font-sans text-white/90 font-light text-lg md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-24">
            We would love to welcome you for a private tour of our estate. Let
            us help you create the celebration of your dreams.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-25">
            <a href="#schedule" className="w-full sm:w-auto px-8 py-4 bg-copper text-white text-xs tracking-widest uppercase hover:bg-copper-dark transition-colors duration-300" data-id="element-26">
              Schedule a Tour
            </a>
            <a href="#inquire" className="w-full sm:w-auto px-8 py-4 border border-white text-white text-xs tracking-widest uppercase hover:bg-white hover:text-charcoal transition-colors duration-300" data-id="element-27">
              Get in Touch
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}